/*! rb-nift-scaled-fixed-v1 — Nifty Pop-ups (the Nift gift campaign, ?utm_source=nift) under
 * rb-desktop-scale.
 *
 * Same failure as rb-digioh-scaled-fixed-v1 in rb-digioh-tophat.js: below 1440px a desktop
 * window scales <html> with a transform, and a transformed root is the containing block for
 * every position:fixed descendant. The welcome popup opened about 3,600px down the homepage,
 * off-screen behind a dimmer over the whole window, and the bottom bar it minimises into sat at
 * the end of the document.
 *
 * The popup has a page dimmer, so while it is up html.rb-nift-popup-open is raised and
 * rb-desktop-scale.js drops the scale, as it does for the age gate. The bar stays up while the
 * visitor browses, so dropping the scale for it would zoom the page under them; instead it is
 * shifted onto the bottom of the window with `translate` every scroll frame. Mobile never
 * scales, so both are no-ops there.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'rb-nift-popup-open';
  var container = null;
  var frame = 0;

  function pageScale() {
    var root = document.documentElement;
    if (!root.classList.contains('rb-desktop-scale')) return 1;
    var s = parseFloat(root.style.getPropertyValue('--rb-desktop-scale'));
    return s > 0 ? s : 1;
  }

  /* The app hides a minimised popup with display:none before removing it. */
  function popupOpen() {
    var holders = container.querySelectorAll('.gonift-popup-holder');
    for (var i = 0; i < holders.length; i++) {
      if (holders[i].style.display !== 'none') return true;
    }
    return false;
  }

  function pinBar(bar, s) {
    if (s === 1) {
      if (bar.style.translate) bar.style.removeProperty('translate');
      return;
    }
    var r = bar.getBoundingClientRect();
    if (!r.height) return;
    var cur = parseFloat(String(bar.style.translate || '').split(' ')[1]) || 0;
    var naturalTop = r.top - cur * s;
    /* Floored so the bar never hangs past the window bottom: any overhang would extend the page
       by that much on every scroll frame. */
    var next = Math.floor((window.innerHeight - r.height - naturalTop) / s);
    if (Math.abs(next - cur) > 0.5) bar.style.translate = '0px ' + next + 'px';
  }

  function sync() {
    frame = 0;
    var root = document.documentElement;
    var open = popupOpen();
    if (root.classList.contains(OPEN_CLASS) !== open) root.classList.toggle(OPEN_CLASS, open);
    var s = pageScale();
    var bars = container.querySelectorAll('.gonift-bottombar');
    for (var i = 0; i < bars.length; i++) pinBar(bars[i], s);
  }

  function queue() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function start() {
    container = document.getElementById('gonift-container');
    if (!container) return;
    try {
      /* The app's `transition: all` on the bar would animate every pin, so it trailed each
         scroll frame by 0.2s. */
      var css = document.createElement('style');
      css.textContent = 'html.rb-desktop-scale .gonift-bottombar{transition:none}';
      document.head.appendChild(css);
    } catch (e) {}
    /* The app mounts the popup and the bar inside its own container, so the observer stays off
       the rest of the page. */
    new MutationObserver(queue).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    /* rb-desktop-scale fires whenever the html scale is applied, changed or cleared */
    window.addEventListener('rb-desktop-scale', queue);
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
